import CharacterSheetTablet from "./CharacterSheetTablet";

export default CharacterSheetTablet;
export { CharacterSheetTablet };
